var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_76","data-name":"Group 76","transform":"translate(-35.789 -37.797)"},[React.createElement("line",{"id":"Line_15","data-name":"Line 15","y1":"20","x2":"19.797","transform":"translate(36.5 38.5)","fill":"none","stroke":"#fff","strokeWidth":"2","key":0}),React.createElement("line",{"id":"Line_17","data-name":"Line 17","x2":"19.797","y2":"20","transform":"translate(36.5 38.5)","fill":"none","stroke":"#fff","strokeWidth":"2","key":1})]));
}

Close.defaultProps = {"viewBox":"0 0 21.218 21.407"};

module.exports = Close;

Close.default = Close;
